import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type ProfileEdit2Payload = {
  idp: number;
  name_end: string;
};

export type ProfileEdit2Event = {
  idp: number;
  name_end: string;
};

const profileEdit2Schema = z.object({
  idp: z.number(),
  name_end: z.string(),
});

export const LID_IDP_MSG2 = {
  value: 0x39,
  name: "Personal Profile Add/Delete Event 2 of 2",
  format: "b.......8Z",
  fields: ["idp", "name_end"],
  postprocess: rec => ({
    idp: rec.idp,
    name_end: rec.name_end,
  }),
  schema: profileEdit2Schema,
} as const satisfies TandemEventDefinition<ProfileEdit2Payload, ProfileEdit2Event>;
